import DealCalculator from '../DealCalculator';

const InvestmentsDirectIdDealCalculatorDetails = () => {
  return <DealCalculator />;
};

export default InvestmentsDirectIdDealCalculatorDetails;
